import React from 'react';
import Calendar from '../components/Calendar.js';
import Map from '../components/Map.js';
import Results from '../components/Results.js';
import ShareButtons from '../components/ShareButtons';
import { TEASERS } from '../helpers/constants';
import TeaserList from '../components/TeaserList';
import rawdata from '../data/data';
import wrangleData from '../helpers/datawrangler';
import Bylines from '../components/Bylines';



const App = React.createClass({
  displayName: "App",
  render () {
    const css = require('./App.scss');

    const data = wrangleData(rawdata);
    return (
      <div style={{position: 'relative', fontFamily: 'Publik'}}>
        <h1 className={css.primHeader}>Amerikanska primärvalen 2016</h1>
        <p className={css.primLead}>{`Den 8 november ska det amerikanska folket välja en ny president. 
                                      Men redan under våren röstar samtliga delstater på vilka kandidater de vill se i sluttampen.`}</p>
        <p className={css.primLead} style={{marginBottom: '3rem'}}>{`De slutliga kandidaterna utses på stora partimöten senare i år. Nu tävlar
                                      de om att vinna så många av deltagarna på dessa möten som möjligt, så kallade delegater.
                                      Här nedan uppdaterar vi löpande delegatfördelningen inom respektive parti.`}</p>

        <Results data={data} />

        <h3 className={css.header} style={{position: 'relative', bottom: '-20px'}}>Kalender</h3>
        <div className={css.winnerHeaders}>
          <p className={css.winnerHeader}>Vinnare (R)</p>
          <p className={css.winnerHeader}>Vinnare (D)</p>
        </div>

        <div style={{clear: 'both'}}></div>

        <Calendar primaries={data} />
        <p className={css.sources}>Källor: AP (valresultat), New York Times och Wall Street Journal (delegatfördelning),
          Republikanska partiet och The Green Papers (valdatum och delegatberäkning).</p>
        <Bylines />
        <ShareButtons title="Kalender för primärvalen" />
        <h3 className={css.header}>{'Mer om presidentvalet'}</h3>
        <TeaserList items={TEASERS} />
      </div>
    );
  }
});
export default App;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/containers/App.js
 **/